import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const PDFRenderer = ({ url, enablePagination = false }) => {
  const canvasRef = useRef(null);
  const [pdf, setPdf] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const loadPdf = async () => {
      try {
        const loadingTask = pdfjsLib.getDocument(url);
        const loadedPdf = await loadingTask.promise;
        setPdf(loadedPdf);
        setNumPages(loadedPdf.numPages);
        setPageNumber(1);
        renderPage(loadedPdf, 1);
      } catch (error) {
        console.error('Error al cargar el PDF:', error);
      }
    };

    loadPdf();
  }, [url]);

  const renderPage = async (pdfDoc, pageNum) => {
    if (!canvasRef.current) return;

    const page = await pdfDoc.getPage(pageNum);
    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = { canvasContext: context, viewport };
    await page.render(renderContext).promise;
  };

  const goToPage = (newPage) => {
    if (pdf) {
      setPageNumber(newPage);
      renderPage(pdf, newPage);
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <canvas
        ref={canvasRef}
        style={{
          width: '100%',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      />

      {enablePagination && (
        <div style={{ marginTop: '10px' }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => goToPage(pageNumber - 1)}
            disabled={pageNumber <= 1}
          >
            Anterior
          </Button>
          <span style={{ margin: '0 15px' }}>
            Página {pageNumber} de {numPages}
          </span>
          <Button
            variant="contained"
            size="small"
            onClick={() => goToPage(pageNumber + 1)}
            disabled={pageNumber >= numPages}
          >
            Siguiente
          </Button>
        </div>
      )}
    </div>
  );
};

export default PDFRenderer;
